import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ViewerPrimaryColorUserStyle } from '../UserCustomization';

import './TabToggle.css';

export class TabToggleComponent extends Component {

  // why did we have duplicate props? keep around in case problems arise from LOIS-187 work
  // static propTypes = {
  //   handleClick: PropTypes.func,
  //   name: PropTypes.string,
  //   checked: PropTypes.string,
  //   leftTab: PropTypes.string,
  //   rightTab: PropTypes.string,
  //   subTab: PropTypes.string,
  //   detailMenuLength: PropTypes.number,
  //   shouldShowRightTab: PropTypes.bool,
  // }

  constructor(props) {
    super(props);
    this.setSelectedTab = this.setSelectedTab.bind(this);
  }

  // original function - keep around in case problems arise from work done on LOIS-187
  // setSelectedTab(selectedTab) {
  //   let currentTab;
  //   if (this.props.subTab === undefined) {
  //     currentTab = 'overview';
  //   } else {
  //     currentTab = this.props.subTab;
  //   }
  //   const tab = selectedTab.toLowerCase();
  //   if (currentTab !== tab) {
  //     this.props.handleClick(tab);
  //   }
  // }

  setSelectedTab(selectedTab) {
    const tab = selectedTab.toLowerCase();
    this.props.handleClick(tab);
  }

  render() {
    let showRightTab;
    if (this.props.detailMenuLength === undefined) {
      showRightTab = 1;
    } else {
      showRightTab = this.props.detailMenuLength && this.props.shouldShowRightTab;
    }
    return (
      <div className="tab-toggle">
        <input
          type="checkbox"
          defaultChecked={this.props.checked}
          name={this.props.name}
          onChange={this.props.handleClick}
          className="tab-toggle__input"
        />
        <ViewerPrimaryColorUserStyle domStyle={!this.props.checked && 'borderBottomColor'}>
          <button
            type="button" onClick={() => this.setSelectedTab(this.props.leftTab)}
            className={`tab-toggle__tab ${!this.props.checked ? 'active' : ''}`}
          >{this.props.leftTab}</button>
        </ViewerPrimaryColorUserStyle>
        {showRightTab > 0 && <ViewerPrimaryColorUserStyle domStyle={this.props.checked && 'borderBottomColor'}>
          <button
            type="button" onClick={() => this.setSelectedTab(this.props.rightTab)}
            className={`tab-toggle__tab ${this.props.checked ? 'active' : ''}`}
          >{this.props.rightTab}</button>
        </ViewerPrimaryColorUserStyle>}
      </div>
    );
  }
}

TabToggleComponent.propTypes = {
  handleClick: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  checked: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  leftTab: PropTypes.string,
  rightTab: PropTypes.string,
  // subTab: PropTypes.string,
  detailMenuLength: PropTypes.number,
  shouldShowRightTab: PropTypes.bool,
};

export default TabToggleComponent;




// WEBPACK FOOTER //
// ./src/components/TabToggle/TabToggle.js